export const FEATURE_CONTROL_GLOBAL_WINDOW_NAMESPACE = '_hs_shareable_forms_feature_flags';
export const QUICK_FETCH_GLOBAL_WINDOW_NAMESPACE = '_hs_shareable_forms_quick_fetch';
export const FLOATING_ALERT_GLOBAL_WINDOW_NAMESPACE = '_hs_sharable_forms_floating_alert';
export const FORMS_ENV_GLOBAL_WINDOW_NAMESPACE = '_hs_shareable_forms_env';